<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="contactAddressForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                contactAddressForm: () => import('../forms/ContactAddressForm'),
                headers: [
                    { text: 'Contact', value: 'contactId', table: 'contacts', form: () => import('../forms/ContactForm') },
                    { text: 'Address', value: 'addressId', table: 'addresses', form: () => import('../forms/AddressForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    addresses: [],
                    contacts: [],
                    items: []
                },
                sorting: [
                    { column: "contactId", direction: "ascending" },
                    { column: "addressId", direction: "ascending" },
                ],
                itemsField: 'contactAddresses',
                editPageName: 'contactAddress',
                apiMethod: 'ContactAddresses',
                claimName: 'ContactAddresses',
                formTitle: 'Contact Address',
                excelTitle: 'Contact Addresses',
                hasEditPage: false,
            }
        },
    };
</script>
